import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'
import Cart from './Cart'
import { useDispatch, useSelector } from 'react-redux'
import { FiMoon, FiSun, FiUser } from 'react-icons/fi'
// import { MdDarkMode } from 'react-icons/md'
import { AiOutlineShoppingCart } from 'react-icons/ai'
import { Menu, Transition } from '@headlessui/react'
import { setCart } from '../store/cartOpenSlice'
import { setDarkTheme, unsetDarkTheme } from '../store/darkThemeSlice'

const links = [
    { href: '/sign-out', label: 'Sign out' },
]


const Navbar = () => {
    const darkTheme = useSelector(state => state.darkTheme.value)
    const dispatch = useDispatch()
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)
    const [user, setUser] = React.useState(null)
    const [show, setShow] = React.useState(false)
    const [theme, setTheme] = React.useState('light');

    useEffect(() => {
        if (localStorage.getItem('token')) {
            setIsLoggedIn(true)
        }

        if (localStorage.getItem('user')) {
            setUser(JSON.parse(localStorage.getItem('user')))
        }
    }, [])

    const handleThemeSwitch = () => {
        setTheme(theme === "dark" ? "light" : "dark");
        localStorage.setItem('theme', theme === "dark" ? "light" : "dark");
        if (darkTheme)
            dispatch(unsetDarkTheme())
        else
            dispatch(setDarkTheme())
    };

    useEffect(() => {
        if (darkTheme || theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [theme, darkTheme]);

    useEffect(() => {
        const localTheme = localStorage.getItem("theme");
        if (localTheme) {
            setTheme(localTheme);

        }
    }, []);

    useEffect(() => {
        if (darkTheme) {
            setTheme('dark');
        }
        else {
            setTheme('light');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <nav className="bg-white dark:bg-black shadow justify-center items-center ">
            <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                <div className="relative flex items-center justify-between h-16">
                    <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                        {/* Mobile menu button*/}
                        <button type="button" className="inline-flex items-center justify-center p-2 rounded-md  focus:outline-none focus:ring-inset " aria-controls="mobile-menu" aria-expanded="false" onClick={() => setShow(!show)}>
                            <span className="sr-only">Open main menu</span>
                            {/* Icon when menu is closed. */}
                            {/* Menu open: "hidden", Menu closed: "block" */}
                            <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                            {/* Icon when menu is open. */}
                            {/* Menu open: "block", Menu closed: "hidden" */}
                            <svg className="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                    </div>
                    <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                        <div className="flex-shrink-0 flex items-center justify-center">
                            <img className="block lg:hidden h-10 ml-10 w-auto  cursor-pointer" src={logo} alt="Workflow" />
                            <Link to="/" className="block md:hidden px-3 py-2 rounded-md text-base font-medium" aria-current="page"><>Go <span className='text-green-600'>Green</span></></Link>
                            <img className="hidden lg:block h-10 w-auto cursor-pointer" src={logo} alt="Workflow" />
                        </div>
                        <div className="hidden sm:block sm:ml-6">
                            <div className="flex space-x-3">
                                {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}
                                <Link to="/" className="p-2 text-sm font-medium" aria-current="page"><>Go <span className='text-green-600'>Green</span></></Link>
                                {user === 'seller' ? <Link to="/inventory" className=" block px-3 py-2 rounded-md text-sm font-medium">Inventory</Link> : <Link to="/shop" className=" block px-3 py-2 rounded-md text-sm font-medium">Shop</Link>}
                                <Link to="/about" className=" p-2 text-sm font-medium" aria-current="page">About</Link>
                                <Link to="/contact" className="p-2 text-sm font-medium" aria-current="page">Contact</Link>
                            </div>
                        </div>
                    </div>

                    {/* Profile dropdown */}
                    {isLoggedIn ? <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"><div className="ml-3 relative">
                        <Menu as="div" className="relative inline-block text-left">
                            <div>
                                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                                    <FiUser className='h-6 w-6 border dark:text-white dark:border-white border-gray-600  rounded-lg p-1 hover:border-black text-gray-600 hover:text-black' />

                                </Menu.Button>
                            </div>

                            <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                            >
                                <Menu.Items className="absolute right-0 z-10 w-40 origin-top-right rounded-md dark:bg-black bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none dark:ring-white">
                                    <div className="">
                                        {user === 'seller' ? <Link className=" font-medium dark:text-white dark:hover:bg-gray-900 text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100" to='/seller/profile'>Profile</Link> : <><Link className=" font-medium dark:text-white dark:hover:bg-gray-900 text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100" to='/orders'>Orders</Link>
                                            <Link className=" font-medium dark:text-white dark:hover:bg-gray-900 text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100" to='/buyer/profile'>Profile</Link>
                                        </>}
                                        {links.map((option) => (
                                            <Menu.Item key={option.label}>
                                                {({ active }) => (
                                                    <Link
                                                        to={option.href}
                                                        className=" font-medium dark:text-white dark:hover:bg-gray-900 text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100"

                                                    >
                                                        {option.label}
                                                    </Link>
                                                )}
                                            </Menu.Item>
                                        ))}
                                    </div>
                                </Menu.Items>
                            </Transition>
                        </Menu>

                    </div>
                        {user === 'seller' ? '' : <button onClick={() => { dispatch(setCart()) }} ><AiOutlineShoppingCart className='h-6 w-6 ml-5 mb-2 border dark:text-white dark:border-white border-gray-600  rounded-lg p-1 hover:border-black text-gray-600 hover:text-black' /></button>}
                    </div>

                        : <>
                            <Link to='/login' className='md:mr-5 text-gray-900 text-sm dark:text-white font-medium hover:text-green-900'>Sign In</Link>
                            <Link className="hidden lg:inline-flex items-center text-sm md:text-base rounded-md px-3 py-1.5 text-center font-medium text-white hover:bg-gradient-to-l md:mr-4 lg:mx-4 bg-gradient-to-r from-green-500 to-green-600" to="/register">Create Free Account</Link>
                            <Link className="hidden md:inline-flex items-center rounded-md px-3 py-1.5 text-center text-base font-medium text-white hover:bg-gradient-to-l lg:mx-4 bg-gradient-to-r from-yellow-500 to-yellow-600" to="/login-seller">Start Selling</Link>
                        </>}
                    <div>
                        {
                            darkTheme ? <button onClick={handleThemeSwitch} className='ml-5 text-gray-900 text-sm dark:text-white font-medium hover:text-green-900'><FiSun className='h-6 w-6 hidden md:block  ' /></button> : <button onClick={handleThemeSwitch} className='ml-5 text-gray-900 text-sm dark:text-white font-medium hover:text-green-900'><FiMoon className='h-6 w-6 hidden md:block  hover:border-black text-gray-600 hover:text-black' /></button>
                        }
                    </div>

                </div>
            </div>
            {/* Mobile menu, show/hide based on menu state. */}
            {show && <div className="sm:hidden transition-transform delay-100000 ease-in-out" id="mobile-menu">
                <div className="px-2 pt-2 pb-3 space-y-1">
                    {
                        darkTheme ? <button onClick={handleThemeSwitch} className=' text-gray-900 text-sm dark:text-white font-medium hover:text-green-900'><FiSun className='h-6 w-6 md:hidden  ml-3' /></button> : <button onClick={handleThemeSwitch} className='ml-3 text-gray-900 text-sm dark:text-white font-medium hover:text-green-900'><FiMoon className='h-6 w-6  md:hidden  hover:border-black text-gray-600 hover:text-black' /></button>
                    }
                    {user === 'seller' ? <Link to="/inventory" className=" block px-3 py-2 rounded-md text-base font-medium">Inventory</Link> : <Link to="/shop" className=" block px-3 py-2 rounded-md text-base font-medium">Shop</Link>}
                    <Link to="/about" className=" block px-3 py-2 rounded-md text-base font-medium">About</Link>
                    <Link to="/contact" className=" block px-3 py-2 rounded-md text-base font-medium">Contact</Link>
                    <Link className="block px-3 py-2 rounded-md text-base font-medium items-center  text-center  text-white hover:bg-gradient-to-l lg:mx-4 bg-gradient-to-r from-yellow-500 to-yellow-600" to="/login-seller">Start Selling</Link>
                </div>
            </div>}

            <Cart />
        </nav>
    )
}

export default Navbar